module.exports = __webpack_public_path__ + "static/docker-f5bbd3e4e729fe50a15ba241254356d7.svg";